<template>
    <div style="display: flex; flex-direction: row;">
        <div>
<!--            <v-select label="hour" dense outlined :items="hours" v-model="hour" />-->
            <select v-model="hour" class="pl-2 py-2 font-weight-light">
                <option v-for="h in hours" :value="h" :key="h" >{{h}}</option>
            </select>
        </div>
        <div class="py-2">:</div>
        <div>
<!--            <v-select label="minute" dense outlined :items="minutes" v-model="minute" />-->
            <select v-model="minute" class="pa-2 font-weight-light">
                <option v-for="h in minutes" :value="h" :key="h"  >{{h}}</option>
            </select>
        </div>
        <div>
<!--            <v-select label="am/pm" dense outlined :items="ampm" v-model="ap"  />-->
            <select v-model="ap" class="pa-2 font-weight-light">
                <option v-for="h in ampm" :value="h" :key="h"  >{{h}}</option>
            </select>
        </div>
    </div>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    name: "TimeDropDown",
    components: {},
    props: ['time'],
    data() {
      return {
        hours: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        minutes: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
        ampm: ['AM', 'PM']
      }
    },
    computed: {
      ...mapState([]),
      hour: {
        get(){
          let t = this.time.split(':')[0]
          if (t[0] === '0') {
            t = t.replace('0', '')
          }
          if(parseInt(t)>12){
            t=t-12
          }
          return t+''
        },
        set(val){
          this.updateTime('hour',val)
        }
      },
      minute: {
        get(){
          let t = this.time.split(':')[1]
          return t+''
        },
        set(val){
          this.updateTime('minute',val)
        }
      },
      ap: {
        get(){
          let t = this.time.split(':')[0]
          return (parseInt(t)>12)?'PM':'AM'
        },
        set(val){
          this.updateTime('ampm',val)
        }
      }
    },
    methods: {
      ...mapActions(['get', 'post']),
      updateTime(key,val) {
        let h = (key==='hour')?val:this.hour
        let m = (key==='minute')?val:this.minute
        let a = (key==='ampm')?val:this.ap
        if (a === 'PM') {
          h = parseInt(this.hour) + 12
        }
        let t = this.time.split(':')

        if (h.length < 2) {
          h = '0' + h
        }
        let tm = h+':'+m+':'+t[2]
        this.$emit('timeupdate',tm)
      }
    }
  }

</script>

<style scoped>

</style>